var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit } from '@angular/core';
import { ModalConfig } from '../../../model/modal-config';
import { PageNames } from '../../../shared/page-names.enum';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { BaseActions } from '../../../shared/base-actions';
import { Emitter } from '../../../shared/utils/emitter/emitter';
import { EmitterConstants } from '../../../shared/emitter-constants';
var TrialAttemptsReachedModalComponent = /** @class */ (function (_super) {
    __extends(TrialAttemptsReachedModalComponent, _super);
    function TrialAttemptsReachedModalComponent(navigationService) {
        var _this = _super.call(this) || this;
        _this.navigationService = navigationService;
        _this.componentName = PageNames.TRIAL_ATTEMPTS_REACHED;
        return _this;
    }
    TrialAttemptsReachedModalComponent.prototype.ngAfterViewInit = function () {
        this.navigationService.resetNavigation();
    };
    TrialAttemptsReachedModalComponent.prototype.onBack = function () {
        Emitter.of(EmitterConstants.BACK_PRESSED).emit(this.componentName);
    };
    return TrialAttemptsReachedModalComponent;
}(BaseActions));
export { TrialAttemptsReachedModalComponent };
